import React from "react";
import {
  sAddShop,
  sPhonePrefix,
  sShops,
  sUpdateShop,
} from "../constants/strings";
import { Stack } from "@mui/material";
import { GenericInput } from "../components/input/GenericInput";
import { FormWrapper } from "../components/styled/StyledComponents";
import { FormButton } from "../components/buttons/FormButton";
import useForm from "../hooks/useForm";
import { useFirebase } from "../hooks/firebase/useFirebase";
import { SHOPS_API } from "../constants/api";
import { Timestamp } from "firebase/firestore";
import { AutofillForm } from "../utils/helpers";
import { createKeywords } from "../utils/keywords";
import { useReportStats } from "../hooks/common/useCommon";

export const ShopForm = (props) => {
  const { data: shopData, setOpen } = props;
  const { loading, addData: addShop, updateData } = useFirebase();
  const { updateReportStats } = useReportStats();

  const { form, onChange, updateFormValues, setForm } = useForm({
    phone: "",
    keywords: [],
  });

  const cleanUp = () =>
    updateFormValues({
      shop_name: "",
      mobile: "",
      location: "",
      phone: "",
      keywords: [],
    });

  function addNewShop() {
    form.timestamp = Timestamp.now();

    addShop(SHOPS_API, form, cleanUp());
    // update report
    updateReportStats(sShops, 1);
  }

  function updateShop() {
    updateData(shopData.docRef, form).then(() => {
      setOpen(false);
    });
  }

  const onSubmit = (e) => {
    e.preventDefault();
    form.keywords = createKeywords(form.shop_name);
    if (shopData) {
      updateShop();
    } else {
      addNewShop();
    }
  };

  AutofillForm(shopData, setForm);

  return (
    <form onSubmit={onSubmit}>
      <FormWrapper>
        <Stack spacing={3}>
          {/* Name */}
          <GenericInput
            label="Shop Name"
            required
            value={form.shop_name}
            name="shop_name"
            onChange={onChange}
          />

          {/* Phone Number */}
          <GenericInput
            label="Phone Number"
            required
            value={form.phone}
            prefix={sPhonePrefix}
            name="phone"
            onChange={onChange}
          />

          {/* Mobile Number */}
          <GenericInput
            label="Mobile Number"
            optional
            value={form.mobile}
            prefix={sPhonePrefix}
            name="mobile"
            onChange={onChange}
          />

          {/* Location */}
          <GenericInput
            label="Location"
            required
            value={form.location}
            name="location"
            onChange={onChange}
          />

          {/* Switch */}
          {/* <GenericSwitch label={sActive} updateFormValue={updateFormValue} /> */}

          {/* Submit */}
          <FormButton loading={loading}>
            {shopData ? sUpdateShop : sAddShop}
          </FormButton>
        </Stack>
      </FormWrapper>
    </form>
  );
};
